import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="vs-outer" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#900000" />
        <stop offset="1" stopColor="#D80000" />
      </linearGradient>
      <linearGradient id="vs-inner" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F59F00" />
        <stop offset="1" stopColor="#E8590C" />
      </linearGradient>
      <linearGradient id="vs-flame" x1="0" y1="1" x2="0.4" y2="0">
        <stop offset="0" stopColor="#E8590C" />
        <stop offset="0.55" stopColor="#F59F00" />
        <stop offset="1" stopColor="#FFD43B" />
      </linearGradient>
    </defs>
    <circle cx="53" cy="56" r="42" fill="url(#vs-outer)" />
    <circle cx="42" cy="40" r="30" fill="#fff" />
    <circle cx="42" cy="40" r="26" fill="url(#vs-inner)" />
    <circle cx="46" cy="30" r="13.5" fill="#FFF8EC" />
    <path d="M46.5 18.5c1.6 4.4 8 7.2 8 13.6a8.2 8.2 0 0 1-16.4 0c0-3.2 1.8-5.6 3.8-7.2-.2 2.8 1 4.6 2.9 5.1.2-4.4-.6-8 1.7-11.5Z" fill="url(#vs-flame)" />
    <path d="M46.6 29.5c.8 2 3.4 3.3 3.4 6a3.4 3.4 0 0 1-6.8 0c0-1.5.9-2.6 1.8-3.3 0 1.2.5 2 1.3 2.2.1-1.9-.3-3.3.3-4.9Z" fill="#fff" />
  </svg>
);

export const Logo = ({ dark = false, testid = "brand-logo-link" }) => (
  <Link to="/" data-testid={testid} className="group flex items-center gap-2.5">
    <LogoMark className="h-10 w-10 transition-transform duration-300 group-hover:rotate-[-8deg]" />
    <span className="flex flex-col whitespace-nowrap leading-none">
      <span className="text-[22px] font-medium tracking-[0.06em]" style={{ fontFamily: "Fraunces, serif" }}>
        <span className={dark ? "text-white" : "text-[#4E4D4D]"}>VIN</span>
        <span className={dark ? "text-slate-300" : "text-[#373435]"}>SAFE</span>
      </span>
      <span className={`mt-0.5 text-[11px] italic ${dark ? "text-slate-400" : "text-[#363334]"}`} style={{ fontFamily: "Fraunces, serif" }}>
        Protecting what matters
      </span>
    </span>
  </Link>
);
